'use strict';

/** Drop " · Pay App #n" when the period is just the same number. */
export function pulsePayAppTitle(appNumber, periodLabel) {
  const n = String(appNumber ?? '').trim()
  const base = n ? `Pay app #${n}` : 'Pay app · Draft'
  const label = String(periodLabel || '').trim()
  if (!label) return base
  const generic = n
    ? new RegExp(`^pay\\s*app\\s*#\\s*${n}$`, 'i')
    : /^pay\s*app\s*#\s*\d+$/i
  if (generic.test(label)) return base
  if (!n && /^draft$/i.test(label)) return base
  return `${base} · ${label}`
}
